import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import Gallery from '../Elements/Gallery';
import GallerySlider from '../Elements/GallerySlider';
import MediaSlider from '../Elements/MediaSlider';

/**
 * Gallery Controller
 *
 * @class
 */
class GalleryController extends AbstractController {
	/**
	 * @constructor
	 */
  constructor() {
	  super();

	  Controller.registerController(this);
	  this._registerElements(...Gallery);
	  this._registerElements(...GallerySlider);
	  this._registerElements(...MediaSlider);
  }

  initializeElements() {
    let _self = this;

    $(Selectors.gallerySlider).each(function () {
      _self.initializeElement($(this).find('> .owl-carousel'), GallerySlider);
    });

    $(Selectors.gallery).each(function () {
      _self.initializeElement($(this), Gallery);
    });

    $(Selectors.mediaSlider).each(function () {
      _self.initializeElement($(this).find('> .owl-carousel'), MediaSlider);
    });
  }

  initializeElement($element, elementClass) {
    if ($element.length > 0) {
      new elementClass($element);
    }
  }
}

export default new GalleryController();
